import { useState } from 'react'
import Switch from '@material-ui/core/Switch'
import { useDispatch } from "react-redux"
import { cambiarEstatusPaqueteAction } from "../../../ducks/paqueteDuck"
import { ToastMessage } from '../../../global/ToastMessage'
import { DialogMessage } from '../../../global/DialogMessage'
import BackDrop from '../../../global/BackDrop'
export default function SwitchAdministracion(props) {
    const { clavePaquete = "", idEstatusPaquete = 1, AdministradoDooddo = false } = props
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        DialogMessage.fire({
            title: '¿Está seguro de aplicar este cambio?',
            text: AdministradoDooddo ?
                `Al desactivar esta opción el paquete pasará a ser visible en el sitio web de Dooddo y será enviado a Hubspot.`
                : `Al activar esta opción el paquete no será visible en el sitio web de Dooddo y no será enviado a Hubspot, solo podrá ser asignable desde el sistema de Oficina.`,
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(cambiarEstatusPaqueteAction({ ClavePaquete: clavePaquete, idEstatusPaquete: idEstatusPaquete, AdministradoDooddo: !event.target.checked })).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ocurrio un problema al actulizar el paquete",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        })
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }

    return (
        <div>
            <label>
                {AdministradoDooddo ? "Externo" : "Interno"}
            </label>
            <Switch
                checked={AdministradoDooddo}
                onChange={handleChange}
                name="checkedA"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
            <BackDrop open={load} />
        </div>
    );
}